import React from 'react'
import { useTenant } from '../../contexts/TenantContext'

const bannerStyle: React.CSSProperties = {
  background: '#fff3cd',
  color: '#856404',
  padding: '10px 16px',
  border: '1px solid #ffeeba',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const TenantMissingBanner: React.FC = () => {
  const { needsRelogin, setNeedsRelogin } = useTenant()
  if (!needsRelogin) return null

  const handleLogoutAndLogin = () => {
    // Limpa token e redireciona para a tela de login/raiz
    localStorage.removeItem('token')
    // opcional: limpar outras chaves relacionadas
    window.location.href = '/login'
  }

  return (
    <div style={bannerStyle} role="alert">
      <div>
        <strong>Sessão inválida ou tenant ausente.</strong>
        <div>Para restaurar o acesso, faça logout e efetue login novamente com uma conta que contenha o tenant correto.</div>
        <div style={{ fontSize: 12, marginTop: 6 }}>Se precisar de ajuda, contate o suporte: <a href="mailto:suporte@ordeno.com.br">suporte@ordeno.com.br</a></div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={handleLogoutAndLogin} style={{ marginLeft: 12 }}>
          Logout & Login
        </button>
        <button onClick={() => setNeedsRelogin(false)} style={{ marginLeft: 12 }}>
          Fechar
        </button>
      </div>
    </div>
  )
}

export default TenantMissingBanner
